/* eslint eqeqeq:off */
import React from "react";
import Modal, {ModalContent, ModalControls} from "../../../Components/Modal";
import Button from "../../../Components/Control/Button";
import Select from "../../../Components/Control/Select";
import {connect} from "react-redux";
import Hospital from "../../../Server/Hospital";
import PropTypes from "prop-types";
import Input from "../../../Components/Control/Input";
import Check from "../../../Components/Control/Check";
import {updateBase} from "../../../Redux/Actions/base";
import {printerTemplate} from "../../../Printer";
import * as moment from "jalali-moment";
import ModalPrint from "../ModalPrint";
import {Tool} from "../../../App";
import Notif from "../../../Components/Notif";
import MyComponent from '../../../Components/MyComponent';

class ModalHospitalDeliverProduct extends MyComponent {
    constructor(props) {
        super(props);
        props.refer.current = this;


        this.state = {
            sections: [
                {id: '', text: '...'},
                ...props.base.hospitalSections.map(item => {
                    return {id: item.sectionId, text: item.sectionName};
                })
            ],
            error: false,
            fields: {}
        };

        this.ref = {
            modal: React.createRef(),
            modalPrint: React.createRef(),
            deliver: React.createRef(),
            close: React.createRef(),
            sectionId: React.createRef(),
            receiverUserStr: React.createRef()
        };
    }

    static defaultProps = {
        refer: {current: null},
        onClose: _ => null,
        onSuccess: _ => null
    };

    static propTypes = {
        refer: PropTypes.object,
        onClose: PropTypes.func,
        onSuccess: PropTypes.func
    };

    validations = {
        sectionId: x => Boolean(x && x[0]?.id) || 'بخش انتخاب نشده است.',
        receiverUserStr: x => Boolean(x) || 'نام تحویل گیرنده وارد نشده است.'
    };

    componentDidMount() {

    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        const {state, props} = this;

        return state.action !== nextState.action ||
            state.error !== nextState.error ||
            state.fields !== nextState.fields ||
            props.base?.hemoReadyProductPrintLabelOnDeliver !== nextProps.base?.hemoReadyProductPrintLabelOnDeliver ||
            props.base?.hemoReadyProductPrintFormOnDeliver !== nextProps.base?.hemoReadyProductPrintFormOnDeliver;
    }

    render() {
        const {state} = this;

        return <React.Fragment>
            <Modal ref={this.ref.modal}
                   name={'ModalHospitalDeliverProduct'}
                   size={'small'}
                   error={state.error}
                   title={'تحویل فرآورده به بخش'}
                   onClose={this.props.onClose}>
                <ModalContent>
                    <div className={'dis-f'}>
                        <Input label={'نام بیمار'} className={'pad-4 fb-10'} value={state.data?.patientFullName} readOnly={true}/>
                        <Input label={'شماره پرونده'} className={'pad-4 fb-10'} value={state.data?.patientFileCode} readOnly={true}/>
                        <Select ref={this.ref.sectionId} value={state.fields?.sectionId} className={'pad-4 fb-20'} label={'نام بخش'} options={state.sections} validation={this.validations.sectionId} onChange={this.setField.bind(this, 'sectionId')}/>
                        <Input ref={this.ref.receiverUserStr} value={state.fields?.receiverUserStr} className={'pad-4 fb-20'} label={'نام تحویل گیرنده'} list={state.receiverList} validation={this.validations.receiverUserStr} onChange={this.setField.bind(this, 'receiverUserStr')}/>
                        <Check className={'pad-h-4'} label={'چاپ خودکار برچسب تحویل'} checked={Boolean(this.props.base?.hemoReadyProductPrintLabelOnDeliver)} onChange={this.autoPrintLabelOnDeliverChangeHandler.bind(this)}/>
                        <Check className={'pad-h-4'} label={'چاپ خودکار فرم خروج'} checked={Boolean(this.props.base?.hemoReadyProductPrintFormOnDeliver)} onChange={this.autoPrintFormOnDeliverChangeHandler.bind(this)}/>
                    </div>
                </ModalContent>
                <ModalControls>
                    <Button refer={this.ref.deliver} className={'mar-4'} theme={'blue'} onClick={this.deliverClickHandler.bind(this)}>تحویل</Button>
                    <Button refer={this.ref.close} className={'mar-4'} onClick={this.close.bind(this)}>بستن</Button>
                </ModalControls>
            </Modal>
            <ModalPrint refer={this.ref.modalPrint}/>
        </React.Fragment>;
    }

    autoPrintFormOnDeliverChangeHandler(value) {
        this.props.updateBase({hemoReadyProductPrintFormOnDeliver: value});
    }

    autoPrintLabelOnDeliverChangeHandler(value) {
        this.props.updateBase({hemoReadyProductPrintLabelOnDeliver: value});
    }

    close(success) {
        this.ref.modal.current.close();

        if (success === true)
            this.props.onSuccess();

        this.props.onClose();
    }

    deliverClickHandler() {
        if (this.validate()) {
            this.ref.deliver.current.loading();
            this.setState({error: null});

            Hospital.deliverProduct({
                crossMatchList: this.state.data.crossMatchList,
                sectionId: this.state.fields?.sectionId[0].id,
                receiverUserStr: this.state.fields?.receiverUserStr
            })
                .then(_ => {
                    if (this.props.base?.hemoReadyProductPrintLabelOnDeliver || this.props.base?.hemoReadyProductPrintFormOnDeliver)
                        this.printOutgoing();

                    this.ref.deliver.current.loading(false);
                    this.close(true);
                })
                .catch(message => {
                    this.ref.deliver.current.loading(false);
                    this.setState({error: message});
                });
        }
    }

    fieldWillUpdate(keys, value, currentFields, nextFields) {
        switch (keys[0]) {
            case 'sectionId':
                if (value?.[0]?.id)
                    this.getSectionReceiverList(value[0].id)
                break;
            default:
                break;
        }
    }

    getSectionReceiverList(sectionId = this.state.fields?.sectionId?.[0]?.id) {
        Hospital.sectionReceiverList({sectionId})
            .then(list => {
                this.setState({receiverList: list.map(item => item.receiverStr)});
            })
            .catch(message => {
                console.log(message);
            });
    }

    open(data, action) {
        const {props} = this;
        if (data.crossMatchList) {
            data.crossMatchList = data.crossMatchList.map(item => {
                return {
                    ...item,
                    enzymeType: props.base?.productTypes.find(pt => item.productTypeId === pt.id)?.enzymeType
                };
            });
        }

        this.setState({
            data,
            error: null,
            fields: {}
        });

        this.ref.modal.current.open();
    }

    printOutgoing() {
        const {state, props} = this;
        const crossMatches = state?.data?.crossMatchList || [];
        const enzymeType1Products = crossMatches.filter(item => item.enzymeType == 1);
        const temp = crossMatches.filter(item => item.enzymeType != 1);
        const otherEnzymeTypeProducts = [];
        const productTypes = Object.fromEntries(props?.base?.productTypes.map(item => [item.id, item.shortName]));
        const prints = [];

        //لیست فرآورده ها رو تو بسته های پنج تایی گروه بندی می کنم چون هر فرم پنج تا رکورد جا میگیره
        while (temp.length > 0) {
            otherEnzymeTypeProducts.push(temp.splice(0, 5));
        }

        if (this.props.base?.hemoReadyProductPrintLabelOnDeliver) {
            prints.push({
                id: 'outgoingLabel',
                title: 'لیبل خروج فرآورده',
                count: 1,
                template: printerTemplate.OUTGOING_LABEL,
                parameters: (crossMatches).map(item => {
                    return {
                        PFullName: state?.data?.patientFullName,
                        PFileCodeStr: state?.data?.patientFileCode,
                        PBloodGroupStr: state?.data?.patientBloodGroupStr,
                        PNationalCode: state?.data?.patientNationalCode,
                        SectionStr: state?.fields?.sectionId[0].text,
                        SendDateTime: moment().format('jYYYY/jMM/jDD HH:mm'),
                        StatusStr: 'سازگار',
                        SamplerFullName: item?.crossMatcherFullName
                    };
                })
            });
        }

        console.log(this.props.base?.hemoReadyProductPrintFormOnDeliver, otherEnzymeTypeProducts);
        if (this.props.base?.hemoReadyProductPrintFormOnDeliver) {
            prints.push({
                id: 'outgoingFormEnzymeType1',
                title: 'فرم نظارت بر تزریق‌ خون',
                count: 1,
                template: printerTemplate.OUTGOING_FORM_ENZYME_TYPE_1,
                parameters: enzymeType1Products.map(item => {
                    return {
                        ProductTypeStr: item?.productTypeStr,
                        ProductExpireDate: item?.productExpireDate ? moment(item.productExpireDate).format('jYYYY/jMM/jDD') : '',
                        ProductNumber: item?.productNumber,
                        ProductBloodGroupStr: item?.productBloodGroupStr,
                        SectionStr: state?.fields?.sectionId[0].text,
                        PatientBloodGroupStr: state?.data?.patientBloodGroupStr,
                        PatientFullName: state?.data?.patientFullName,
                        PatientFileCodeStr: state?.data?.patientFileCode,
                        PatientFather: state?.data?.patientFatherName,
                        PatientNationalCode: state?.data?.patientNationalCode,
                        PatientBirthDate: state?.data?.patientBirthDate,
                        CrossMatcherFullName: item?.crossMatcherFullName,
                        ReceiverFullName: state?.fields?.receiverUserStr,
                        SenderFullName: props?.user?.userFullName,
                        SendDateTime: moment().format('jYYYY/jMM/jDD HH:mm'),
                        HospitalStr: props?.user?.hospitalFullName,
                        ProvinceStr: props?.user?.provinceName,
                        CityStr: props?.user?.cityName,
                        Sazghar: 'سازگار',
                        GenderId: state?.data?.patientGenderId,
                        CrossMachDateTime: item?.createDateTime ? moment(item?.createDateTime).format('jYYYY/jMM/jDD') : '',
                        NeedDateTime: ''
                    };
                })
            }, {
                id: 'outgoingFormOtherEnzymeType',
                title: 'فرم نظارت بر تزریق پلاکت',
                count: 1,
                template: printerTemplate.OUTGOING_FORM_OTHER_ENZYME_TYPE,
                parameters: otherEnzymeTypeProducts.map(item => {
                    let pCounts = item.reduce((pCounts, item) => {
                        pCounts[item.productTypeId] = (pCounts[item.productTypeId] || 0) + 1;
                        return pCounts;
                    }, {});
                    pCounts = Object.entries(pCounts).map(item => `(${productTypes[item[0]]}=${item[1]})`).join(' ');
                    return {
                        HospitalStr: props?.user?.hospitalFullName,
                        ProvinceStr: props?.user?.provinceName,
                        CityStr: props?.user?.cityName,
                        SectionStr: state?.fields?.sectionId[0].text,
                        PatientFullName: state?.data?.patientFullName,
                        PatientNationalCode: state?.data?.patientNationalCode,
                        PatientFileCodeStr: state?.data?.patientFileCode,
                        PatientFatherName: state?.data?.patientFatherName,
                        PatientBirthDate: state?.data?.patientBirthDate,
                        PatientBloodGroupStr: state?.data?.patientBloodGroupStr,
                        ProductsCount: pCounts,
                        GenderId: state?.data?.patientGenderId,
                        SendDateTime: moment().format('jYYYY/jMM/jDD HH:mm'),
                        SenderFullName: props?.user?.userFullName,
                        ReceiverFullName: state?.fields?.receiverUserStr
                    };
                }),
                datatables: otherEnzymeTypeProducts.map(item => {
                    return {
                        DT: item.map(item => {
                            return {
                                ProductBloodGroupStr: item?.productBloodGroupStr,
                                ProductExpireDate: item?.productExpireDate ? moment(item?.productExpireDate).format('jYYYY/jMM/jDD') : '',
                                ProductNumber: item?.productNumber,
                                ProductTypeStr: item?.productTypeStr
                            };
                        })
                    };
                })
            });
        }

        if (prints.length)
            this.ref.modalPrint.current.open({
                title: 'چاپ برچسب/فرم فرآورده',
                prints
            });
    }

    validate() {
        let validate;

        validate = Tool.validate(this.ref.sectionId,
            this.ref.receiverUserStr);

        if (validate !== true)
            new Notif({message: validate.message, theme: 'error'}).show();

        return validate === true;
    }
}

const mapStateToProps = state => {
    return {
        base: state.base,
        user: state.user
    };
};

const mapDispatchToProps = dispatch => {
    return {
        updateBase: props => dispatch(updateBase(props))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalHospitalDeliverProduct);